import { Text, TextProps } from '@air/zephyr';

export interface AgencySectionTitleProps extends Pick<TextProps, 'children' | 'tx'> {}

export const AgencySectionTitle = ({ children, tx }: AgencySectionTitleProps) => {
  return (
    <Text
      as="h2"
      tx={{
        color: 'macaw500',
        fontFamily: 'Brice-SemiBoldSemiExpanded',
        fontSize: [28, 40],
        letterSpacing: ['-0.03em', '0.03em'],
        ...tx,
      }}
      variant="text-heading-40"
    >
      {children}
    </Text>
  );
};
